import axios from 'axios';
import Swal from 'sweetalert2'; // TODO: SWAL must be decoupled from this service
import store from '../../store';

const httpRequest = axios.create({
  baseURL: process.env.VUE_APP_STORE_MAP_API_URL
});

let loadingCount = 0;

const defaultErrorText = '系統錯誤';

const handleErrors = ({ message = { info: defaultErrorText } }, statusCode) => {
  // 移除全域 Loading
  store.commit('toggleLoading', false);

  if ([401, 403].includes(statusCode)) {
    window.sessionStorage.clear();
  }

  if (statusCode === 422) {
    Swal.fire({
      title: '驗證失敗',
      html: '驗證失敗',
      icon: 'error'
    });
  } else if (statusCode === 500) {
    Swal.fire({
      title: '操作失敗',
      html: message,
      icon: 'error'
    });
  } else if (statusCode === 401) {
    Swal.fire({
      title: message,
      icon: 'info'
    }).then(() => {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    });

    return Promise.reject(message);
  } else if (statusCode === 403) {
    Swal.fire({
      title: message,
      icon: 'info'
    }).then(() => {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    });

    return Promise.reject(message);
  } else if (statusCode >= 300) {
    Swal.fire({
      title: '操作失敗',
      html: message,
      icon: 'error'
    });
  } else {
    Swal.fire({
      title: '很抱歉系統錯誤',
      html: 'Error[Not Has Message Code]',
      icon: 'error'
    }).then(() => {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    });
  }
};

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    if (window.showRequestLoadingSwal === true) {
      loadingCount--;
      if (loadingCount === 0) {
        Swal.close();
      }
    }

    if (response.data && response.data.error) {
      Swal.fire({
        title: '發生錯誤[Error: status 200 error]',
        html: '請重試一次',
        icon: 'error'
      });
    }

    return response;
  }

  throw response;
}

function getResponse(response) {
  switch (response.status) {
    case 200:
      return { data: response.data, response };

    case 204:
      return { response };

    default:
      return { data: response.data, response };
  }
}

function resolveOrReject({ data, response }) {
  if (!(response.status === 200)) return Promise.reject(data);
  return Promise.resolve(data);
}

// REF: https://github.com/axios/axios#handling-errors
function catchHandler(error) {
  if (window.showRequestLoadingSwal === true) {
    loadingCount--;
    if (loadingCount === 0) {
      Swal.close();
    }
  }

  if (error.response) {
    handleErrors(error.response.data, error.response.status);

    return Promise.reject(error.response.data);
  } if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    /* eslint-disable no-alert */
    console.error(error);
    return Promise.reject(error);
  }
}

function promiseFetch(request) {
  if (window.showRequestLoadingSwal === true) {
    if (loadingCount === 0) {
      Swal.fire({
        allowOutsideClick: false,
        onOpen: function onOpen() {
          Swal.showLoading();
        }
      });
    }
    loadingCount++;
  }

  return request
    .then(checkStatus)
    .then(getResponse)
    .then(resolveOrReject)
    .catch(catchHandler);
}

export default ({
                  endpoint,
                  method = 'GET',
                  body = {},
                  headers = {},
                  options = {}
                }) => {
  const requestHeader = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: window.sessionStorage.getItem('token'),
    ...headers
  };
  const url = encodeURI(endpoint);

  switch (method) {
    case 'GET':
    case 'DELETE':
      return promiseFetch(
        httpRequest({
          url,
          method,
          data: body,
          headers: requestHeader,
          ...options
        })
      );

    case 'POST':
    case 'PUT':
      return promiseFetch(
        httpRequest({
          url,
          headers: requestHeader,
          method,
          data:
            requestHeader['Content-Type'] === 'multipart/form-data'
              ? body
              : JSON.stringify(body),
          ...options
        })
      );

    default:
      throw new Error(
        'Unrecognized request method. Please make a correct one.'
      );
  }
};
